import { render, staticRenderFns } from "./LinkAssetInventoryItem.vue?vue&type=template&id=8650af26&"
import script from "./LinkAssetInventoryItem.vue?vue&type=script&lang=js&"
export * from "./LinkAssetInventoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports